import { render, staticRenderFns } from "./add_rule.vue?vue&type=template&id=7cbfda52&scoped=true&"
import script from "./add_rule.vue?vue&type=script&lang=js&"
export * from "./add_rule.vue?vue&type=script&lang=js&"
import style0 from "./add_rule.vue?vue&type=style&index=0&id=7cbfda52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbfda52",
  null
  
)

export default component.exports